import React, { useRef } from 'react';
import { useInView } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { Target, Lightbulb } from 'lucide-react';
import AboutCard from './about/AboutCard';

const About = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Soft Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[linear-gradient(30deg,#1e40af_12%,transparent_12.5%,transparent_87%,#1e40af_87.5%,#1e40af),linear-gradient(150deg,#1e40af_12%,transparent_12.5%,transparent_87%,#1e40af_87.5%,#1e40af)] bg-[length:80px_140px] bg-[position:0_0,0_0,40px_70px,40px_70px]" />
      </div>

      {/* Smooth Gradient Overlays */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500/5 rounded-full blur-3xl" />
      </div>

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <AboutCard
            Icon={Target}
            title={t.about.title}
            description={t.about.description}
            isInView={isInView}
            direction="left"
            cardClass="bg-gradient-to-br from-blue-500/10 to-purple-500/10 border-blue-500/20"
            titleGradient="from-blue-400 to-cyan-400"
            iconClass="bg-gradient-to-br from-blue-500 to-blue-600 shadow-blue-500/50"
          />
          <AboutCard
            Icon={Lightbulb}
            title={t.approach.title}
            description={t.approach.description}
            isInView={isInView}
            direction="right"
            cardClass="bg-gradient-to-br from-orange-500/10 to-pink-500/10 border-orange-500/20"
            titleGradient="from-orange-400 to-pink-400"
            iconClass="bg-gradient-to-br from-orange-500 to-orange-600 shadow-orange-500/50"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
